import {useEffect,useState} from 'react';
import {updatePredictionRecords} from '../utils/predictionRecords';
import {sixLabel} from '../utils/sixPrediction';

export function PredictionRecords({gameKey,history,kind,prediction,targetIssue,targetTime,disabled,hidden=false}) {
  const key=`prediction-records:${prediction.version}:${gameKey}`;
  const [records,setRecords]=useState([]);
  const [failed,setFailed]=useState(false);
  useEffect(()=>{
    try {
      const parsed=JSON.parse(localStorage.getItem(key)||'[]');
      const stored=Array.isArray(parsed)?parsed:[];
      const next=updatePredictionRecords(stored,{history,kind,prediction:disabled?{}:prediction,targetIssue,targetTime,now:Date.now()});
      localStorage.setItem(key,JSON.stringify(next)); window.dispatchEvent(new CustomEvent('prediction-records-updated',{detail:{key}})); setRecords(next); setFailed(false);
    } catch { setFailed(true); }
  },[key,history,kind,prediction,targetIssue,targetTime,disabled]);
  if(hidden) return null;
  return <details className="prediction-records"><summary>开奖前记录核对（{records.length}条）</summary>
    <p className="muted">仅保存本浏览器页面打开时、下一期开奖时间前产生的结果；每期首次保存后不覆盖。最多保留200条，清除浏览器数据会丢失，不是服务器发布证明。</p>
    {failed&&<p role="status">浏览器存储不可用，无法保存核对记录。</p>}
    <p className="muted">模型版本：{prediction.version}；各版本记录分开保存。</p>
    {!records.length&&<p className="muted">暂无记录；需有效输出及明确的下一期开奖时间。</p>}
    {records.map(row=><div className="prediction-record" key={row.targetIssue}><strong>{row.targetIssue}期</strong>
      {row.fields ? <span>{row.fields.map(field=>`${field.label}：${sixLabel(field.value)}${field.mode==='default'?'（默认）':''}`).join(' · ')}</span> : <span>{row.choices?.join(',')||'—'} / {row.excluded?`杀${row.excluded}`:'—'}</span>}
      <small>保存：{new Date(row.savedAt).toLocaleString()} · 后续样本{row.total}次</small>
      {row.fields ? <small>{row.actualFields?row.actualFields.map(field=>`${field.label}：${sixLabel(field.value)||'未知'}（${field.hit===null?'跳过':field.hit?'中':'未中'}）`).join(' · '):'等待开奖'}</small> : <small>实际：{row.actual||'等待开奖'} · 双组：{row.choicesHit==null?'—':row.choicesHit?'中':'未中'} · 杀组：{row.excludedHit==null?'—':row.excludedHit?'中':'未中'}</small>}
    </div>)}
  </details>;
}
